import { render, staticRenderFns } from "./DelegatingView.vue?vue&type=template&id=2b617094&scoped=true"
import script from "./DelegatingView.vue?vue&type=script&lang=js"
export * from "./DelegatingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b617094",
  null
  
)

export default component.exports